module.exports = __webpack_public_path__ + "img/02.35a5518f.png";